<template>
  <div>
    <div style="margin: 10px 0">
      <!-- <el-input style="width: 200px;" type="text" v-model="pondsid" placeholder="请输入池塘号" suffix-icon="el-icon-search"></el-input> -->
      <!-- <div style="width: 380px; display: inline-block;" class="block">
          <el-date-picker
              style="width: 380px;"
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              >
          </el-date-picker>
      </div> -->
      <!-- <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button> -->
      <el-button type="primary" @click="load" icon="el-icon-refresh">重置</el-button>
      <!-- <el-button style="float:right; " type="primary" @click="exp">导出<i class="el-icon-top"></i></el-button> -->
      <!-- <el-upload
        action="http://localhost:9090/user/import" :on-success = 'handelsuccess' style="float:right;margin-left: 10px">
        <el-button style="float:right;" type="primary">导入<i class="el-icon-bottom"></i></el-button>
      </el-upload> -->
      <el-button style="float:right; margin-left: 10px" type="danger" @click = "deleteBatch">批量删除<i class="el-icon-remove-outline"></i></el-button>
      <!-- <el-select v-model="pondid" clearable placeholder="请选择要查看的池塘"style="float:right">
        <el-option v-for="item in options2" 
        :key="item.id"
        :label="item.name"
        :value="item.id"></el-option> 
      </el-select> 
      <el-select v-model="comid" clearable placeholder="请选择要查看的公司" v-if = "role === '超级管理员'" style="float:right">
        <el-option v-for="item in options1" 
        :key="item.id"
        :label="item.name"
        :value="item.id"></el-option>
      </el-select> -->
      <el-button style="float:right;" type="primary" @click = "handAdd" icon="el-icon-circle-plus-outline">新增</el-button>
    </div>
    <!-- eslint-disable-next-line -->
    <el-table :data="tableData" border stripe :header-cell-class-name="headerBg" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <!-- <el-table-column prop="id" label="ID" width="100">
      </el-table-column> -->
      <el-table-column prop="name" label="省份">
      </el-table-column>
      <el-table-column prop="area" label="面积(亩)">
      </el-table-column>
      <el-table-column prop="year" label="数据年份">
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <!-- eslint-disable-next-line -->
        <template slot-scope="scope"><!-- scope 拿到数据-->
          <el-button type="success" @click = "handEdit(scope.row)" style="margin-right: 5px">编辑<i class="el-icon-edit"></i></el-button>
          
          <el-popover
            placement="top"
            width="160"
            trigger="click">
            <p>您确定删除吗</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible = false">取消</el-button>
              <el-button type="primary" size="mini" @click=handdele(scope.row.id)>确定</el-button>
            </div>
            <el-button type="danger"  slot="reference">删除<i class="el-icon-remove-outline"></i></el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div style="padding: 10px 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="信息新增或修改" :visible.sync="dialogFormVisible" width="30%" >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="省份">
          <el-select v-model="form.name" placeholder="请选择省份">
            <el-option v-for="province in provinces" :key="province" :label="province" :value="province"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面积(亩)">
          <el-input v-model="form.area"></el-input>
        </el-form-item>
        <el-form-item label="年份">
          <el-date-picker
           :key="datePickerKey"
            v-model="form.year"
            type="year"
            placeholder="选择年份"
            value-format=yyyy>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click ='shutDown'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
  </template>
  
  <script>
  export default {
    name: "User",
    data () {
      return{
        tableData: [],
        pondsid: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        dialogFormVisible: false,
        form: {},
        multipleSelection: {},
        headerBg: 'headerBg',
        data: {},
        value1: '',
        options1:[],
        options2:[],
        user: localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{},
        pondid: null,
        comid:null,
        role: (localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{}).role,
        dialogVisible: true,
        provinces: [
        "北京", "天津", "上海", "重庆", "河北", "山西", "辽宁", "吉林", "黑龙江", "江苏", "浙江", "安徽", "福建", "江西", "山东", "河南", "湖北", "湖南", "广东", "海南", "四川", "贵州", "云南", "陕西", "甘肃", "青海", "台湾", "内蒙古", "广西", "西藏", "宁夏", "新疆", "香港", "澳门"
      ],
      datePickerKey: 0,
      }
    },
    mounted () {
      //请求分页查询
      this.load()
      // if(this.role == "超级管理员"){
      //   this.getcompanies()
      // }else{
      //   this.getPonds(this.user.companyid)
      // }
    },
    methods: {
      load () {//点击页码进行get请求
        this.request.get('/api/chinaMap/page', {
          params: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            // pondid: this.pondid,
            // companyId: this.user.companyid,
          }
        }).then(res => {
          this.tableData = res.records
          this.total = res.total
        }).catch(error => {
          console.error(error)
        })
      },
      getcompanies () {
        this.request.get('/api/companies/').then(res => {
          if(res.code === "200"){
            this.options1 = res.data.map(item => {
              return {
                id: item.id,
                name: item.name
              }
            })
          }else{
            console.log(res.code, res.data);
          }
        })
      },
      getPonds (comid){
          if (isNaN(comid)) {  
          // 如果 comid 不是数字，则设置一个默认值或者处理错误  
          comid = 0; // 或者你可以抛出一个错误，或者根据需要处理这种情况  
          }  
          this.request.get('/api/ponds/getponds', {
              params:{
                  comid: comid
              }
          }).then(res=> {
              if(res.code === "200") {
                  this.options2 = res.data.map(item => {
                      return {
                          id: item.id,
                          name: item.name
                      }
                  })
              }else{
                  console.log(res.msg);
              }
              
          }).catch(error =>{
              console.log(error);
          })
      },
      save () { // 新增或更新
        this.request.post('/api/chinaMap/', this.form).then(res => {
          if (res) {
            this.$message.success('保存成功')
            this.dialogFormVisible = false
            this.load()
          } else {
            this.$message.success('保存失败')
          }
        })
      },
      seleteLoad(){
        this.request.get('/api/chinaMap/page', {
          params: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            pondid: this.pondid,
          }
        }).then(res => {
          this.tableData = res.records
          this.total = res.total
        }).catch(error => {
          console.error(error)
        })
      },
      handAdd() {
        this.form = { name: '', year: '', amount: '' }
        this.datePickerKey++;
        this.dialogFormVisible = true //打开表单
      },
      handEdit(row) { //把row里的数据传给表单
        this.originalForm = JSON.parse(JSON.stringify(row));
        this.form = JSON.parse(JSON.stringify(row));
        this.form.year = row.year ? String(row.year) : '';
        this.datePickerKey++; // 每次更新 key
        this.dialogFormVisible = true;
      },
      handdele (id) { //通过id删除
        this.request.delete('/chinaMap/' + id).then(res => {
          if (res) {
            this.$message.success('删除成功')
            this.load()
          } else {
            this.$message.success('删除失败')
          }
        })
      },
      handleSelectionChange (val) {
        console.log(val)
        this.multipleSelection = val
      },
      deleteBatch () {
        // eslint-disable-next-line
        let ids = this.multipleSelection.map(val => val.id)
        this.request.delete('/user/del/batch' + ids).then(res => {
          if (res) {
            this.$message.success('批量删除成功')
            this.load()
          } else {
            this.$message.success('删除失败')
          }
        })
      },
      shutDown () {
        this.dialogFormVisible = false
      },
      exp () { //导出
        window.open("http://localhost9090/user/export")
      },
      handelsuccess () {
        this.$message.success('文件上传成功')
        this.load()
      },
      handleSizeChange (pageSize) {
        this.pageSize = pageSize
        this.load() 
      },
      handleCurrentChange (pageNum) {
        this.pageNum = pageNum
        console.log(this.pageNum);
        this.load()
      }
    },
    watch: {
      comid (comid) {
        this.getPonds(comid)
      },
      pondid (pondid) {
        this.seleteLoad()
      }
    },
  }
  </script>
  
  <style scoped>
  
  </style>
  